@if (current$(); as entry) {
  <sol-banner [banner]="entry.banner" (action)="onActionPress(entry)" (visibleChange)="onVisibleChange(entry)">
    @if (paged$()) {
      <div
        class="sol-banner-navigation"
        slot="navigation"
        role="group"
        aria-live="off"
        [attr.aria-label]="'sol-banner.navigation' | translate"
      >
        <output class="sol-banner-position" aria-live="polite">{{ position$() | translate }}</output>
        <sol-button
          #previousArrow
          class="sol-banner-step-previous"
          [class.sol-banner-step-live]="!atFirst$()"
          [type]="SolButtonType.transparent"
          [small]="true"
          [icon]="SolIcon.chevron_up"
          [disabled]="atFirst$()"
          [ariaLabel]="'sol-common.previous' | translate"
          (click)="onPrevious()"
        />

        <div class="sol-banner-dots" aria-hidden="true" [style.height]="dotsStyle$().height">
          <div class="sol-banner-dots-track" [style.transform]="dotsStyle$().transform">
            @for (dot of dots$(); track dot.index) {
              <div class="sol-banner-dot" [class.sol-banner-dot-current]="dot.current"></div>
            }
          </div>
        </div>

        <sol-button
          #nextArrow
          class="sol-banner-step-next"
          [class.sol-banner-step-live]="!atLast$()"
          [type]="SolButtonType.transparent"
          [small]="true"
          [icon]="SolIcon.chevron_down"
          [disabled]="atLast$()"
          [ariaLabel]="'sol-common.next' | translate"
          (click)="onNext()"
        />
      </div>
    }
  </sol-banner>
}
